module.exports = __webpack_public_path__ + "static/x5a-041e7e79b2115a71d7795ffb2d3986dc.png";